
import {useCoreUiHtmlify, useCoreUiHtmlifyProps} from "~/core-ui/vue/ui/useCoreUiHtmlify";
import {ExtractPropTypes} from "vue";

export default {
    name: "CoreUiHtmlify",
    props: {
        ...useCoreUiHtmlifyProps()
    },
    setup(props: Readonly<ExtractPropTypes<ReturnType<typeof useCoreUiHtmlifyProps>>>) {
        let htmlify = useCoreUiHtmlify(props);
        return htmlify.render;
    }
}
